import React, { useEffect, useState } from "react"
import { Col, Row, Card, Button, Steps, List, Avatar } from "antd"
import { RouteComponentProps, useHistory } from "react-router-dom"
import SettingsPageSimple from "components-old/common/SettingsPage/SettingsPageSimple"
import FacebookSvg from "../svgs/FacebookSvg"
import { useGenericStore, useStore } from "hooks"
// import { FacebookProvider, useLogin } from "react-facebook"
// import { envKeys } from "config/envs.config"
import { general } from "store"
import toast from "lib/toast"
import axios from "axios"
import { endpoints } from "config/endpoints.config"
import request from "lib/request"
import FacebookLogin from "@greatsumini/react-facebook-login"
import { envKeys } from "config/envs.config"

function Step2(props: { accessToken: string }) {
  const history = useHistory()
  const [pages, setPages] = useState<any>([])
  const [loading, setLoading] = useState(-1)
  const [loadingPages, setLoadingPages] = useState(false)
  const { all: faceChannels } = useGenericStore((state) => state.channelsFacebook)

  async function getPages() {
    setLoadingPages(true)
    axios({
      method: "get",
      url: endpoints.FACEBOOK_GRAPH_API + props.accessToken,
    })
      .then((response) => {
        console.log(response)
        setPages(response.data)
      })
      .catch((e) => {
        console.error(e)
      })
      .finally(() => {
        setLoadingPages(false)
      })
  }

  useEffect(() => {
    getPages()
  }, [])

  return (
    <List
      itemLayout="horizontal"
      dataSource={pages?.data}
      loading={loadingPages}
      renderItem={(page: any) => {
        const isConnected = faceChannels.find((f) => f.pageId == page.id)
        return (
          <Card style={{ width: "100%", marginBottom: 15 }} className="gray">
            <List.Item
              actions={[
                <Button
                  type="primary"
                  loading={loading == page.id}
                  disabled={!!isConnected}
                  onClick={(e) => {
                    setLoading(page.id)
                    request
                      .save(endpoints.FACEBOOK, {
                        avatar: page.picture.data.url,
                        pageId: page.id,
                        name: page.name,
                        accessToken: page.access_token,
                        groupIds: [],
                      })
                      .then((response) => {
                        toast.success(
                          <span>
                            Conectado ao canal de Facebook <strong>{response?.data.name}</strong>
                          </span>,
                        )
                        history.push("/settings/channels")
                      })
                      .finally(() => {
                        setLoading(-1)
                      })
                  }}
                >
                  {isConnected ? "Conectado" : "Conectar"}
                </Button>,
              ]}
            >
              <List.Item.Meta
                avatar={<Avatar src={page?.picture?.data?.url} size="large" />}
                title={page.name}
                description={page.id}
                style={{ alignItems: "center" }}
              />
            </List.Item>
          </Card>
        )
      }}
    />
  )
}
const getTextsByStep = (step: 0 | 1 | 2) => {
  switch (step) {
    case 0:
      return {
        centerTitle: "Add canal de Facebook",
        description: (
          <span>
            Vamos integrar sua página com o Kinbox. Para isso, clique no botão abaixo e selecione a página que você quer integrar no
            Facebook.
          </span>
        ),
      }
    case 1:
      return {
        centerTitle: "Conecte uma página...",
        description: <span>Selecione a página que você deseja conectar abaixo</span>,
      }
    case 2:
      return {
        centerTitle: "Conectar canal",
        description: "Leia o QRCode abaixo no WhatsApp do seu celular para conectar.",
      }
  }
}

function AddFacebook() {
  const [step, setStep] = useState<0 | 1 | 2>(0)
  const [data, setData] = useState<{
    access_token: string
    token_type: string
    expires_in: number
  }>()

  const history = useHistory()

  const { _domain } = useStore(general)
  const appId = ((envKeys as any)[_domain.key] || {}).facebook_app_id || envKeys.staging.facebook_app_id
  // const appId = "406703890178760"
  const isStaging = _domain.key === "staging"

  const configId = isStaging ? "931498214790263" : "795441432613433"

  return (
    <SettingsPageSimple
      style={{
        width: 800,
      }}
      onBack={() => history.push("/settings/channels/new")}
      backTo="/settings/channels/new"
      title={
        <Row align="middle">
          Canais {"> "}
          <Row align="middle">
            <span
              style={{
                width: 24,
                height: 24,
                display: "flex",
                marginRight: 10,
                marginLeft: 10,
              }}
            >
              <FacebookSvg />
            </span>
            Facebook
          </Row>
        </Row>
      }
      tabTitle="Canais > Facebook"
      centerTitle={
        <Row justify="center">
          <Col>{getTextsByStep(step)?.centerTitle}</Col>
        </Row>
      }
      description={
        <Row justify="center">
          <span style={{ maxWidth: 500 }}>{getTextsByStep(step)?.description}</span>
        </Row>
      }
      helpText={
        <span>Conecte-se aos aplicativos de mensagens mais usados pelos seus clientes e responda todos em sua caixa de entrada.</span>
      }
      center
    >
      <Row justify="center">
        <Steps current={step} style={{ maxWidth: 400 }}>
          <Steps.Step />
          <Steps.Step />
          <Steps.Step />
        </Steps>
      </Row>
      <br />
      <br />
      <br />
      {step == 0 && (
        <div>
          <Row justify="center">
            <FacebookLogin
              appId={appId}
              scope="pages_show_list, pages_messaging, pages_manage_metadata, business_management"
              initParams={
                {
                  version: "v19.0",
                } as any
              }
              language="pt_BR"
              onSuccess={(response) => {
                setData({
                  ...response,
                  access_token: response.accessToken,
                } as any)
                setStep(1)
                console.log("Login Success!", response)
              }}
              onFail={(error) => {
                console.log("Login Failed!", error)
              }}
              onProfileSuccess={(response) => {
                console.log("Get Profile Success!", response)
              }}
              loginOptions={
                {
                  config_id: configId,
                } as any
              }
              render={({ onClick }) => (
                <Button icon={<i className="fab fa-facebook" />} size="large" onClick={onClick} type="primary">
                  Conectar página do Facebook
                </Button>
              )}
            />
          </Row>
        </div>
      )}
      {step == 1 && <Step2 accessToken={data?.access_token!} />}
      <br />
    </SettingsPageSimple>
  )
}

export default AddFacebook
